import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../../../redux/actions/authAction";
import cloneDeep from "lodash/cloneDeep";
import { Oval } from "react-loader-spinner";
import Badge from "react-bootstrap/Badge";
import CoachDashboardInputFields from "../../../components/CoachDashboardInputFields";
import { socket } from "../../../constants/socket";

const CoachDashboard = () => { 
  const [activityData, setActivityData] = useState([]);
  const [newComment, setNewComment] = useState(null);
  const [comment, setComment] = useState("");
  const [userId, setUserId] = useState("");
  const [coachData, setCoachData] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const persistFilterState = useSelector(
    (state) => state?.getCoachDashboardData?.persistFilter
  );

  const [data, setData] = useState(0);

  const dispatch = useDispatch();
  const myRef = useRef(null);

  const today = new Date();
  useEffect(() => {
    dispatch(authActions.getCoachActivityNewsFeed());
    dispatch(authActions.getDueSoonClientList());
    dispatch(authActions.getTodayActivityClientList());
    dispatch(authActions.getNeedAttentionClientList());
    dispatch(authActions.getUserEngagementData());
    socketConnectionFun();
  }, []);
  const { coachActivityNewsFeedData } = useSelector(
    (state) => state.getCoachActivityNewsFeed
  );
  const { coachClientsData } = useSelector((state) => state.getClientsData);
  const { user } = useSelector((state) => state.authentication);
  const myRef2 = useRef(coachActivityNewsFeedData);
  useEffect(() => {
    if (Array.isArray(coachActivityNewsFeedData?.data)) {
      let rrr = [...coachActivityNewsFeedData.data];
      setActivityData(rrr);
    } else {
      setActivityData([]);
    }
  }, [coachActivityNewsFeedData]);
  const {
    dueSoonClientList,
    todayActivityClientList,
    needAttentionClientList,
    coachEngagementsData,
    userEngagementData
  } = useSelector((state) => state.getCoachDashboardData);

  const socketConnectionFun = () => {
    socket.on("new-notification", (notification) => {});
  };

  const sendCommentBtn = (id, str) => {
    if (str !== "") {
      socket?.emit("activity-comments", {
        senderId: user?.data?.userId,
        msg: str,
        activityId: id,
      });
    }
  };
  // const updateComments = (newComment) => {
  //   let findIndex = coachActivityNewsFeedData?.data?.findIndex(
  //     (e) => e._id == newComment.activityId
  //   );
  //   // if (findIndex !== -1) {
  //   //   let item = coachActivityNewsFeedData?.data[findIndex];
  //   //   item.activityComments = newComment.messages;
  //   //   let newArray = cloneDeep(coachActivityNewsFeedData?.data);
  //   //   setCoachData(newArray);
  //   //   setLoading(false);
  //   // }
  //   if (findIndex !== -1) {
  //     let newArray = cloneDeep(coachActivityNewsFeedData?.data);
  //     newArray[findIndex].activityComments = newComment.messages;
  //     setCoachData(newArray);
  //   }
  // };

  const updateComments = (newComment) => {
    // Find the index of the activity to update
    const findIndex = coachData.findIndex(
      (activity) => activity._id === newComment.activityId
    );
    if (findIndex !== -1) {
      // Update the activity's comments
      const updatedActivity = {
        ...coachData[findIndex],
        activityComments: newComment.messages,
      };
      // Update the coachData state with the updated activity
      const updatedData = [
        ...coachData.slice(0, findIndex),
        updatedActivity,
        ...coachData.slice(findIndex + 1),
      ];
      setCoachData(updatedData);
      setLoading(false);
    }
  };

  const selectFilter = (obj) => {
    if (obj._id === 1) {
      setCoachData(coachActivityNewsFeedData?.data);
      setSelectedUser({ _id: 1, firstName: "All Clients" });
      return;
    }
    let t = coachActivityNewsFeedData?.data.filter(
      (e) => e.userInfo._id === obj._id
    );
    setCoachData(t);
    dispatch({ type: "PERSIST_FILTER_IN_COACH_DASHBOARD", payload: obj });
    setSelectedUser(obj);
  };

  const activityCompletionColor = (data) => {
    if (data?.status === "Complete") {
      return "green"
    } else if (data?.status === "Started") {
      return "orange"
    } else {
      return "red"
    }
  }
  useEffect(() => {
    setLoading(true);
    setCoachData(coachActivityNewsFeedData?.data);
    setSelectedUser({ _id: 1, firstName: "All Clients" });
    setLoading(false);
  }, [coachActivityNewsFeedData]);

  useEffect(() => {
    setLoading(true);
    socket.on("new-comments", (newComment3) => {
      setNewComment(newComment3);
      setLoading(false);
    });
  }, [socket]);

  // useEffect(() => {
  //   if (newComment !== null) {
  //     setLoading(true);

  //     updateComments(newComment);
  //     selectFilter(persistFilterState);

  //   }
  // }, [newComment]);

  useEffect(() => {
    if (newComment !== null) {
      setLoading(true);
      updateComments(newComment);
    }
  }, [newComment]);

  useEffect(() => {
    setLoading(false); // Set loading state to false after all necessary updates
  }, [coachData]);

  // console.log("COACH DATA :::: ", coachData);

  return (
    <>
      <div className="row coach-dashboard-container">
        <div className="col-md-3 col-lg-3 p-0">
          <div className="main-container-left">
            <div className="day-date-leftpanel">
              <div className="day-leftpanel">
                {moment(today).format("dddd")}
              </div>
              <div className="date-leftpanel">
                {moment(today).format("MMM Do")}
              </div>
            </div>
            <div className="today-activity-container">
              <h6>Today's Activity Performers </h6>
              {/* <Dropdown className="d-inline mx-2 dropAtStart">
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="btn-update-list"
                >
                  Today's Activity
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="#">person 1</Dropdown.Item>
                  <Dropdown.Item href="#">person 2</Dropdown.Item>
                  <Dropdown.Item href="#">person 3</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}{" "}
            </div>
            <div className="today-activity-data-list">
              {todayActivityClientList?.data?.map(
                (todayActivityData, index) => {
                  return (
                    <div key={index} className="t-a-container">
                      <div className="today-activity-data d-flex">
                        <div className="client-img">
                          {todayActivityData?.imageUrl ? (
                            <img src={todayActivityData?.imageUrl} alt="img" />
                          ) : (
                            <img
                              className="profile-pic"
                              src="/img/sample_img_2.png"
                              alt="img"
                            />
                          )}
                        </div>
                        <div className="client-name pt-1">
                          <div>
                            {todayActivityData?.firstName}{" "}
                            {todayActivityData?.lastName}
                          </div>
                          <div
                            className="client-name-status"
                            style={{
                              fontWeight: "bolder",
                              color: activityCompletionColor(todayActivityData)
                            }}
                          >
                            {todayActivityData?.status}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-6 p-0">
          <div className="main-container-center">
            {loading ? (
              <>
                <Oval
                  visible={true}
                  height="50"
                  width="700"
                  color="black"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  secondaryColor="#f3f3f3"
                />
              </>
            ) : (
              <>
                <div className="updates-selector">
                  <p>Updates from</p>
                  <div className="dropdown-update-selector">
                    <Dropdown className="d-inline mx-2 dropdownAtEnd">
                      <Dropdown.Toggle
                        id="dropdown-autoclose-true"
                        className="btn-update-list"
                      >
                        {selectedUser?.firstName}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {coachClientsData?.data
                          ?.slice()
                          ?.sort((a, b) =>
                            (a.firstName ?? '').localeCompare(b.firstName ?? '')
                          )
                          ?.reduce((acc, client) => [...acc, client], [{ _id: 1, firstName: "All", lastName: "Clients" }])
                          ?.map((clientData, index) => {
                            return (
                              <Dropdown.Item
                                key={clientData._id || index}
                                href="#"
                                onClick={() => selectFilter(clientData)}
                              >
                                {clientData?.firstName} {clientData?.lastName}
                              </Dropdown.Item>
                            );
                          })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                {coachData?.length > 0 ? (
                  loading ? (
                    <Oval
                      visible={true}
                      height="50"
                      width="700"
                      color="black"
                      ariaLabel="oval-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      secondaryColor="#f3f3f3"
                    />
                  ) : (
                    <>
                      <div className="activity-news-feed-container">
                        {coachData?.map((activityData, index) => {
                          return (
                            <div
                              key={index}
                              className="updates-from-client-container"
                            >
                              <div className="u-f-c-header">
                                <div className="client-img-name d-flex">
                                  <div className="client-img">
                                    {activityData?.userInfo?.imageUrl ? (
                                      <img
                                        src={activityData?.userInfo?.imageUrl}
                                        alt="img"
                                      />
                                    ) : (
                                      <img
                                        className="profile-pic"
                                        src="/img/sample_img_2.png"
                                        alt="img"
                                      />
                                    )}
                                  </div>
                                  <div className="client-name-and-date-news-feed">
                                    <div className="client-name">
                                      <h5>
                                        {activityData?.userInfo?.firstName}{" "}
                                        {activityData?.userInfo?.lastName}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="u-f-c-body">
                                <div className="events-and-checkbox ">
                                  <div className="events d-flex">
                                    <img
                                      src="/img/Rectangle client.png"
                                      alt=""
                                    />
                                    <p>{activityData?.title}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )
                ) : (
                  <h1
                    style={{
                      height: "100%",
                      width: "100%",
                      marginTop: "50%",
                    }}
                  >
                    No feeds yet
                  </h1>
                )}
              </>
            )}
          </div>
        </div>
        <div className="col-md-3 col-lg-3 p-0">
          <div className="main-container-right">
            <div className="engagement-report-container p-3">
              <h6 className="mb-3">Client Engagement Report</h6>
              <div style={{ overflowX: "auto", maxHeight: "750px" }}>
                <table className="table table-sm table-hover" style={{ fontSize: "12px" }}>
                  <thead className="">
                    <tr>
                      <th>Name</th>
                      <th>Streak</th>
                      <th>StepDay</th>
                      <th>Activity</th>
                      <th>Read</th>
                      <th>Total%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userEngagementData?.data?.length > 0 ? (
                      userEngagementData.data.map((report, index) => (
                        <tr key={index}>
                          <td className="fw-bold">{report.userName}</td>
                          <td>
                            <span style={{ fontSize: '12px' }} className="badge text-dark">
                              {report.streakValue}
                            </span>
                          </td>
                          <td>{report.stepInJourney}</td>
                          <td>{report.activity?.percentage}%</td>
                          <td>{report.read?.percentage}%</td>
                          <td>
                            <span style={{ fontSize: '12px' }}>{report.totalContent?.percentage}%</span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center text-muted">No report data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoachDashboard;
